/* Articles & News — list filtering/sorting/pagination and the article banner
   carousel. Every behaviour is bound per section root, so the sections keep
   working when the theme editor re-renders them or when one page holds two. */
(function () {
  'use strict';

  var SVG_PREV =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function pageWindow(current, total) {
    if (total <= 7) {
      var all = [];
      for (var i = 1; i <= total; i++) all.push(i);
      return all;
    }

    var pages = [1];
    var start = Math.max(2, current - 1);
    var end = Math.min(total - 1, current + 1);

    if (start > 2) pages.push('ellipsis');
    for (var p = start; p <= end; p++) pages.push(p);
    if (end < total - 1) pages.push('ellipsis');
    pages.push(total);

    return pages;
  }

  function initList(root) {
    var list = root.matches('[data-an-list]') ? root : root.querySelector('[data-an-list]');
    if (!list || list.dataset.anBound === 'true') return;
    list.dataset.anBound = 'true';

    var grid = list.querySelector('[data-an-grid]');
    var searchInput = list.querySelector('[data-an-search]');
    var sortSelect = list.querySelector('[data-an-sort]');
    var emptyMessage = list.querySelector('[data-an-empty]');
    var pagination = list.querySelector('[data-an-pagination]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-an-item]'));
    var perPage = parseInt(list.dataset.perPage, 10) || 6;
    var currentPage = 1;

    function currentMatches() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      if (!query) return items.slice();

      return items.filter(function (item) {
        return (item.dataset.search || '').indexOf(query) !== -1;
      });
    }

    function sortItems(matches) {
      var oldestFirst = sortSelect && sortSelect.value === 'oldest';
      return matches.sort(function (a, b) {
        var aDate = parseInt(a.dataset.date, 10) || 0;
        var bDate = parseInt(b.dataset.date, 10) || 0;
        return oldestFirst ? aDate - bDate : bDate - aDate;
      });
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      pagination.innerHTML = '';
      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;

      var listEl = document.createElement('ul');
      listEl.className = 'an-pagination__list';

      function addButton(content, page, options) {
        var opts = options || {};
        var li = document.createElement('li');
        var el = document.createElement(opts.disabled || opts.plain ? 'span' : 'button');

        if (el.tagName === 'BUTTON') {
          el.type = 'button';
          el.addEventListener('click', function () {
            currentPage = page;
            update();
            list.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }

        el.className = 'an-pagination__item' + (opts.className ? ' ' + opts.className : '');
        el.innerHTML = content;
        if (opts.label) el.setAttribute('aria-label', opts.label);
        if (opts.current) el.setAttribute('aria-current', 'page');
        if (opts.disabled) el.classList.add('an-pagination__item--disabled');

        li.appendChild(el);
        listEl.appendChild(li);
      }

      addButton(SVG_PREV, currentPage - 1, {
        disabled: currentPage === 1,
        label: 'Previous page',
      });

      pageWindow(currentPage, totalPages).forEach(function (page) {
        if (page === 'ellipsis') {
          addButton('&hellip;', 0, { plain: true, className: 'an-pagination__item--ellipsis' });
          return;
        }
        addButton(String(page), page, {
          current: page === currentPage,
          label: 'Page ' + page,
        });
      });

      addButton(SVG_NEXT, currentPage + 1, {
        disabled: currentPage === totalPages,
        label: 'Next page',
      });

      pagination.appendChild(listEl);
    }

    function update() {
      var matches = sortItems(currentMatches());
      var totalPages = Math.max(1, Math.ceil(matches.length / perPage));
      if (currentPage > totalPages) currentPage = totalPages;

      items.forEach(function (item) {
        item.hidden = true;
      });

      var start = (currentPage - 1) * perPage;
      matches.slice(start, start + perPage).forEach(function (item) {
        item.hidden = false;
        // Re-appending keeps the DOM order in sync with the chosen sort.
        grid.appendChild(item);
      });

      if (emptyMessage) emptyMessage.hidden = matches.length !== 0;
      renderPagination(totalPages);
    }

    if (searchInput) {
      var debounce;
      searchInput.addEventListener('input', function () {
        window.clearTimeout(debounce);
        debounce = window.setTimeout(function () {
          currentPage = 1;
          update();
        }, 150);
      });
      // Stop the browser from navigating if the input sits inside a form.
      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentPage = 1;
        update();
      });
    }

    update();
  }

  function initBanner(root) {
    var banner = root.querySelector('[data-an-banner]');
    if (!banner || banner.dataset.anBound === 'true') return;
    banner.dataset.anBound = 'true';

    var viewport = banner.querySelector('[data-an-banner-viewport]');
    var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-an-banner-dot]'));
    if (!viewport || dots.length < 2) return;

    var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-an-banner-slide]'));

    function setCurrent(index) {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var slide = slides[index];
        if (!slide) return;
        viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
        setCurrent(index);
      });
    });

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var width = viewport.clientWidth;
        if (!width) return;
        var index = Math.round(viewport.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        setCurrent(index);
      });
    });

    setCurrent(0);
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = Array.prototype.slice.call(context.querySelectorAll('[data-an-section]'));

    if (context !== document && context.matches && context.matches('[data-an-section]')) {
      roots.push(context);
    }

    roots.forEach(function (root) {
      initList(root);
      initBanner(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
